import { render, staticRenderFns } from "./ActivityTable.vue?vue&type=template&id=a2dbd2ca&scoped=true&"
import script from "./ActivityTable.vue?vue&type=script&setup=true&lang=js&"
export * from "./ActivityTable.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ActivityTable.vue?vue&type=style&index=0&id=a2dbd2ca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2dbd2ca",
  null
  
)

export default component.exports